<template>
  <select
    v-model="valor"
    @input="
      (event) => {
        $emit('input', event.target.value);
      }
    "
    @change="emitChange()"
  >
    <template v-for="(dato, index) in data">
      <option :value="dato.value" :key="index">{{ dato.text }}</option>
    </template>
  </select>
</template>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>

<script>
export default {
  name: "customSelect",
  components: {},
  props: ["value", "data"],
  data() {
    return {
      valor: "",
    };
  },
  methods: {
    updateModel() {
      this.$emit("input", this.$refs.customSelect.value);
    },
    emitChange() {
      this.$emit("onChange");
    },
  },
  computed: {},
  watch: {
    value: function(newValue) {
      this.valor = newValue;
    },
  },
  beforeMount: function() {
    this.valor = this.value;
  },
  mounted() {},
};
</script>
